import React from 'react';
import { FilterFieldType } from './CustomFilter';
import { Nav } from 'react-bootstrap';

interface BooleanExtraAdvanceOptionProps {
	field: FilterFieldType;
	advOption: FilterFieldType['advancedOptions'][number];
	activeFilters: { [key: string]: string[] };
	setActiveFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const BooleanExtraAdvanceOption: React.FC<BooleanExtraAdvanceOptionProps> = ({ field, advOption, activeFilters, setActiveFilters }) => {
	const hasMatchingExtraParam = advOption.extraQueryParams.some((param) => (activeFilters[param.name] ?? []).includes(param.value));
	const filterValue = hasMatchingExtraParam ? activeFilters[`${field.name}_${advOption.name}`]?.[0] : undefined;
	const extraFilterValues = advOption.extraQueryParams.map((param) => `${param.name}=${param.value}`).join('&');
	const initialActiveKey =
		filterValue && extraFilterValues ? `${field.name}_${advOption.name}-${filterValue}&${extraFilterValues}` : undefined;

	const [activeKey, setActiveKey] = React.useState<string>(initialActiveKey);

	return (
		<div
			style={{
				borderRadius: '8px',
				padding: '0.5rem',
				border: '1px solid #C7CFD7',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				// maxWidth: '70%',
			}}
		>
			{field.booleanLabel || `${advOption.switchLabelPrefix} ${field.pluralLabel} ${advOption.switchLabelSuffix}`}
			<Nav variant="pills">
				{advOption.options.map((option) => {
					const advOptionName = field.name === advOption.name ? field.name : `${field.name}_${advOption.name}`;
					const advOptionValue = `${option.value}`;
					const extraParams = advOption.extraQueryParams.map((param) => `${param.name}=${param.value}`).join('&');
					const key = `${advOptionName}-${advOptionValue}&${extraParams}`;

					let isOneExtraSelectedDisabled = false;
					let areMoreExtraSelectedDisabled = false;

					advOption.extraQueryParams?.forEach((param) => {
						const key = param.name;
						const values = activeFilters[key];

						if (!values) return;

						if (values.length === 1 && !hasMatchingExtraParam) {
							isOneExtraSelectedDisabled = true;
						}
						if (values.length > 1) {
							areMoreExtraSelectedDisabled = true;
						}
					});
					const isDisabled =
						(isOneExtraSelectedDisabled || areMoreExtraSelectedDisabled) &&
						activeFilters[`${field.name}_${advOption.name}`]?.[0] !== option.value;

					return (
						<Nav.Item key={key}>
							<Nav.Link
								eventKey={key}
								disabled={option.value !== 'none' && isDisabled}
								active={activeKey === key || (!activeKey && key === `${advOptionName}-none&${extraParams}`)}
								onClick={() => {
									setActiveKey(key);

									setActiveFilters((prev) => {
										const newFilters = { ...prev };

										const isActive =
											(newFilters[advOptionName] ?? []).includes(advOptionValue) &&
											(advOption.extraQueryParams ?? []).every((extraQueryParam) =>
												(newFilters[extraQueryParam.name] ?? []).includes(extraQueryParam.value),
											);

										if (advOptionValue === 'none') {
											(advOption.extraQueryParams ?? []).forEach((extraQueryParam) => {
												if (!newFilters[extraQueryParam.name]) return;
												newFilters[extraQueryParam.name] = newFilters[extraQueryParam.name].filter(
													(value) => value !== extraQueryParam.value,
												);
												if (newFilters[extraQueryParam.name].length === 0) {
													delete newFilters[extraQueryParam.name];
												}
											});

											const anyExtrasRemaining = (advOption.extraQueryParams ?? []).some(
												(extraQueryParam) => (newFilters[extraQueryParam.name] ?? []).length > 0,
											);
											if (!anyExtrasRemaining) {
												delete newFilters[advOptionName];
											}
										} else if (!isActive) {
											newFilters[advOptionName] = [advOptionValue];

											(advOption.extraQueryParams ?? []).forEach((extraQueryParam) => {
												const prevExtra = newFilters[extraQueryParam.name] ?? [];
												if (!prevExtra.includes(extraQueryParam.value)) {
													newFilters[extraQueryParam.name] = [...prevExtra, extraQueryParam.value];
												}
											});
										}

										return newFilters;
									});
								}}
							>
								{option.label}
							</Nav.Link>
						</Nav.Item>
					);
				})}
			</Nav>
		</div>
	);
};

export default BooleanExtraAdvanceOption;
